export const EVENT_SUBSCRIPTION_PRODUCT_KEYS = {
  /** Single-flow Flow Base Plan: contributors + upload + playout. */
  BASE_CAPACITY: 'base_capacity',
  /** Multi-flow Event Base Plan (Event dashboard): contributors + upload. */
  BASE_CAPACITY_EVENT: 'base_capacity_event',
  /** Multi-flow Flow Base Plan (Flow widget): playout. */
  BASE_CAPACITY_FLOW: 'base_capacity_flow',
  EVENT_BROADCAST: 'event_broadcast',
  STAGE_READY: 'stage_ready',
} as const;

export type EventSubscriptionProductKey =
  (typeof EVENT_SUBSCRIPTION_PRODUCT_KEYS)[keyof typeof EVENT_SUBSCRIPTION_PRODUCT_KEYS];

/** Paid Base Plan / Broadcast tiers (upgrade path). */
export const EVENT_PAID_TIERS = ['BASIC', 'SMART', 'PRO'] as const;

/** Base Plan columns including Free (planning / testing, no overage). */
export const EVENT_BASE_PLAN_TIERS = ['FREE', 'BASIC', 'SMART', 'PRO'] as const;

/**
 * Quotas steppable on single-flow `base_capacity` / multi event line (excl. playout on event line).
 * Click sizes come from catalog `overagePrices[].step`, not FE constants.
 */
export const EVENT_CAPACITY_STEPPABLE_QUOTA_KEYS = ['contributors', 'data_transfer_gb', 'playout_hours'] as const;

export const EVENT_CAPACITY_EVENT_STEPPABLE_QUOTA_KEYS = ['contributors', 'data_transfer_gb'] as const;

export const EVENT_CAPACITY_FLOW_STEPPABLE_QUOTA_KEYS = ['playout_hours'] as const;
